import { useState } from 'react';

import { BsDownload } from 'react-icons/bs';

import RequireCapability from '#globalComponents/RequireCapability/RequireCapability';
import ActionScopeButton from '#globalComponents/Table/actions/ActionScopeButton';
import { useError } from '#globalContexts/ErrorContext';

import { useLeadData } from '../../../contexts/LeadDataContext';
import { useLeadJobs } from '../../../contexts/LeadJobContext';
import CSVExportModal from '../../CSVExportModal/CSVExportModal';
import { AiSearchForm } from '../LeadOverviewContainer/SubComponents/AiSearchForm/AiSearchForm';
import { ContactEnrichmentModal } from '../LeadOverviewContainer/SubComponents/ContactEnrichmentModal/ContactEnrichmentModal';

const isActiveEnrichmentJob = (job) =>
	job.jobType === 'contactEnrichment' && (job.status === 'queued' || job.status === 'running');

const LeadScopeActions = () => {
	const [showCSVExportModal, setShowCSVExportModal] = useState(false);
	const { selectedSearchQuery, leads } = useLeadData();
	const {
		runningJobs,
		hasRunningEnrichmentJob,
		hasCancellingEnrichmentJob,
		handleStartEnrichment,
		handleAbortSearchJob,
	} = useLeadJobs();
	const { showError } = useError();

	const isSharedQuery = Boolean(selectedSearchQuery?.isShared);

	const handleExportCSV = () => {
		if (!selectedSearchQuery) {
			showError({
				title: 'Keine Suchanfrage ausgewählt',
				message: 'Ohne ausgewählte Suchanfrage kann kein CSV-Export durchgeführt werden',
			});
			return;
		}
		setShowCSVExportModal(true);
	};

	return (
		<>
			{!isSharedQuery && (
				<>
					<AiSearchForm />
					<ContactEnrichmentModal
						onConfirm={handleStartEnrichment}
						isLoading={hasRunningEnrichmentJob}
						onAbort={handleAbortSearchJob}
						runningEnrichmentJob={runningJobs.find(isActiveEnrichmentJob)}
						isCancellingEnrichment={hasCancellingEnrichmentJob}
					/>
				</>
			)}
			{leads.length > 0 && (
				<RequireCapability required="leads.export">
					<ActionScopeButton
						icon={<BsDownload />}
						onClick={handleExportCSV}
						disabled={!selectedSearchQuery}
						title="Suchergebnisse als CSV exportieren"
					>
						CSV Export
					</ActionScopeButton>
				</RequireCapability>
			)}

			{showCSVExportModal && selectedSearchQuery && (
				<CSVExportModal
					isOpen={showCSVExportModal}
					onClose={() => setShowCSVExportModal(false)}
					prospectQueryId={selectedSearchQuery.id}
					prospectQueryName={selectedSearchQuery.queryName}
				/>
			)}
		</>
	);
};

export default LeadScopeActions;
